import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Row, Col, Alert, Card } from "react-bootstrap";
import { loginUser, fetchUserDetails } from "../api/api";
import { useUser } from "../UserContext";

const Login = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const { setUser } = useUser();

    const activeStoreName = localStorage.getItem('active_store_name');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setErrorMessage(''); //clear any previous error messages

        try {
            const token = await loginUser(username, password);
            if (token) {
                const userDetails = await fetchUserDetails();
                setUser(userDetails);
                onLogin(token);
                navigate('/');
            }
        } catch (error) {
            setErrorMessage('Login failed. Please check your credentials.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100 vw-100">
            <Row>
                <Col>
                    <Card className="p-4">
                        <Card.Body>
                            <Card.Title className="text-center mb-4">Login</Card.Title>
                            {activeStoreName && (
                                <div className="text-center fw-bold mb-3" style={{ fontSize: '1.1rem' }}>
                                    Store: {activeStoreName}
                                </div>
                            )}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="formUsername">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="formPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                                <Button className="w-100" variant="success" type="submit" disabled={isLoading}>
                                    {isLoading ? 'Logging in...' : 'Login'}
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
